import React, { useState, useEffect } from 'react';
import FilterModal from '../Modal/FilterModal';
import {
  filterButton
} from '../Pagination/FilterStyles';
import { Button } from 'app/src/elements/buttons';
import * as Colors from '../../styles/colors';
import FilterSelect from './Select';

const Filter = ({clearFilters, children, filters, setFilters, filterType}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Button
        style={filterButton}
        label="Filter Options"
        onPress={() => setShowModal(true)}
      />
      {
        showModal &&
          <FilterModal
            setShowModal={setShowModal}
            clearFilters={clearFilters}
            children={children}
          />
      }
    </>
  );
};

Filter.FilterSelect = FilterSelect;

export default Filter;
